/**
 * ProtectedShell — v.1-D §7.19.
 *
 * The authenticated-routes gate. Three-branch render:
 *   1. `loading`     → <PageSkeleton/>          (no flash of unauthenticated chrome)
 *   2. `!user`       → <Navigate to="/sign-in"  state={{ from: location }} replace />
 *                      (the `from` lets the sign-in handler return the user
 *                       to their originally requested page)
 *   3. authenticated → <AppLayout/>             (chrome + outlet)
 *
 * Pure render-time gate per §7.19 — NO useEffect, NO useState. An effect-
 * based gate would race against the first render and is forbidden here.
 */
import type { JSX } from 'react';
// DevOps 2026-05-26: useAuth, Navigate, useLocation, PageSkeleton imports
// removed — they're only referenced in the commented-out original logic
// below. Re-add when reverting the bypass.
import { AppLayout } from './AppLayout';

export function ProtectedShell(): JSX.Element {
  // DevOps 2026-05-26: auth gate bypassed for dev clicking. Same rationale
  // as the v1 frontend bypass — auth is a different team's scope, only
  // placeholder code exists today (PayloadAuth reads a cross-domain cookie
  // at .mediatiquepress.one that is never set when served from *.pages.dev).
  // With the gate active, every route redirects to /sign-in. Revert this
  // commit when the auth team wires the backend.
  return <AppLayout />;

  // Original (restored on revert):
  // const { user, loading } = useAuth();
  // const location = useLocation();
  // if (loading) return <PageSkeleton />;
  // if (!user) return <Navigate to="/sign-in" state={{ from: location }} replace />;
  // return <AppLayout />;
}
